<template>
  <div class="toast-pop" @touchmove.prevent>
    <div
      class="toast"
      v-html="toastText"
      :style="{ width: selfWidth ? `${selfWidth}rem` : '' }"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'Toast',
  data() {
    return {}
  },
  props: ['toastText', 'selfWidth']
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.toast-pop {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
  .toast {
    // position: absolute;
    // left: 50%;
    // top: 45%;
    max-width: 80%;
    // transform: translate(-50%,-50%);
    padding: 0.3rem 0.4rem;
    background: rgba(48, 53, 61, 0.92);
    border-radius: 0.45rem;
    font-size: 0.26rem;
    line-height: 1.5;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    color: rgba(255, 255, 255, 1);
    text-align: center;
  }
}
</style>
